import React, { useRef, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { ProductCard, ProductCardSkeleton } from './Card';
import { ProductModal } from './Modal';
import { ProductApi } from '../app/api/product.api';


export function EquipementContainer() 
{
  const scrollRef = useRef(null);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('mobilier');

  const product = ProductApi(); 
    
  const fetchData = async ({ queryKey }) => {
    const [ , category] = queryKey;
    const { data } = await product.findAllByCategory(category);
    return data.data;
  };

  const { isLoading, data = [], error } = useQuery({
    queryKey: ["productsByCategory", selectedCategory],
    queryFn: fetchData,
    enabled: !!selectedCategory,
  });


  const handleEdit = ( product ) => {
    setSelectedProduct( product );
    setShowDetail(true);
  }

  const handleFilter = ( category ) => {
    setSelectedCategory(category);
  }


  const scroll = (direction) => {
    const { current } = scrollRef;
    if (direction === 'left') {
      current.scrollBy({ left: -300, behavior: 'smooth' });
    } else {
      current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };


  return (

    <div className="new-arrivals">

        <div className="d-flex mb-2 border-bottom">
          <button className={`nav-tab ${(selectedCategory === 'mobilier') && 'active'}`} onClick={ ()=> handleFilter('mobilier') }> Mobilier </button>
          <button className={`nav-tab ${(selectedCategory === 'informatique') && 'active'}`} onClick={ ()=> handleFilter('informatique') }> Informatique </button>
          <button className={`nav-tab ${(selectedCategory === 'biomedicale') && 'active'}`} onClick={ ()=> handleFilter('biomedicale') }> Biomédicale </button>
        </div>

        <div className="row g-4">
          <div className="container my-5 best-sellers-section">
              {/* Header du Slider */}
              <div className="d-flex justify-content-between align-items-end mb-4">
                {
                  (selectedCategory === 'biomedicale') && (
                    <div>
                      <h3 className="fw-bold text-muted mb-1"> Nos Equipements Biomédicaux </h3>
                      <p className="text-muted mb-0"> Des matériels biomédicaux sûrs et durables pour une prise en charge optimale </p>
                    </div>
                  )
                }
                {
                  (selectedCategory === 'informatique') && (
                    <div>
                      <h3 className="fw-bold text-muted mb-1"> Nos Equipements Informatiques </h3>
                      <p className="text-muted mb-0"> Des équipements IT performantes et fiables pour une productivité optimale </p>
                    </div>
                  )
                }
                {
                  (selectedCategory === 'mobilier') && (
                    <div>
                      <h3 className="fw-bold text-muted mb-1"> Nos mobiliers bureaux </h3>
                      <p className="text-muted mb-0"> Du mobilier professionnel conçu pour votre confort </p>
                    </div>
                  )
                }
                <div className="d-flex align-items-center gap-4">
                  <div className="slider-nav-buttons">
                    <button className="nav-btn me-2" onClick={() => scroll('left')}>
                      <i className="bi bi-chevron-left"></i>
                    </button>
                    <button className="nav-btn active" onClick={() => scroll('right')}>
                      <i className="bi bi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* Zone du Slider */}
              <div className="product-slider-container" ref={scrollRef}>
                <div className="d-flex gap-4">

                  {/* Loading */}
                  {isLoading && (
                    [...Array(4)].map((_, index) => (
                      <ProductCardSkeleton key={index} />
                    ))
                  )}

                  {/* Error */}
                  {!isLoading && error && (
                   <div className="text-center p-4 border alert alert-danger w-100">
                     Une erreur est survenue. Veuillez vérifier votre connexion.
                   </div>
                  )}

                  {/* Data */}
                  {!isLoading && !error && Array.isArray(data) && data.length > 0 && (

                    data.slice(0, 15).map((product, index) => (
                      <ProductCard
                        key={index}
                        product={product}
                        detail={() => handleEdit(product)}
                      />
                    ))
                  )}

                  {/* Liste vide */}
                  {!isLoading && !error && Array.isArray(data) && data.length === 0 && (
                    <div className="bg-white border p-4 text-center text-secondary w-100">
                      La liste des produits de cette catégorie est vide.
                    </div>
                  )}

                </div>
              </div>
              
            </div>
        </div>

        {/* Modal de previsualisation */}
        {
          selectedProduct && ( <ProductModal show={showDetail} product={selectedProduct} onHide={() => setShowDetail(false)} /> )
        }   
    </div>
  );
}




export function SoftwareContainer() 
{
  const scrollRef = useRef(null);
  const [state, setState] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const product = ProductApi(); 
    
  const fetchData = async () => { 
    const {data} = await product.findAllByCategory('logiciel');
    return data.data; 
  }
  const { isLoading, data=[], error } = useQuery({  queryKey: ["softwares"], queryFn: fetchData });


  const handleEdit = ( product ) => {
    setSelectedProduct( product );
    setShowDetail(true);
  }

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (direction === 'left') {
      current.scrollBy({ left: -300, behavior: 'smooth' });
    } else {
      current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };


  return (

    <div className="new-arrivals">

        <div className="d-flex mb-2 border-bottom">
          <button className={`nav-tab active `}> Logiciel </button>
        </div>

        <div className="row g-4">
          <div className="container my-5 best-sellers-section">
              {
                  state && ( <ProductModal close={ ()=> setState(false) } /> )
              }
              {/* Header du Slider */}
              <div className="d-flex justify-content-between align-items-end mb-4">
                <div>
                  <h3 className="fw-bold text-muted mb-1"> NOS LOGICIELS </h3>
                  <p className="text-muted mb-0"> Des logiciels sur mesure pour accélérer votre transformation digitale. </p>
                </div>
                <div className="d-flex align-items-center gap-4">
                  <div className="slider-nav-buttons">
                    <button className="nav-btn me-2" onClick={() => scroll('left')}>
                      <i className="bi bi-chevron-left"></i>
                    </button>
                    <button className="nav-btn active" onClick={() => scroll('right')}>
                      <i className="bi bi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* Zone du Slider */}
              <div className="product-slider-container" ref={scrollRef}>
                <div className="d-flex gap-4 ">

                  {/* Loading */}
                  {isLoading && (
                    [...Array(4)].map((_, index) => (
                      <ProductCardSkeleton key={index} />
                    ))
                  )}

                  {/* Error */}
                  {!isLoading && error && (
                   <div className="text-center p-4 border alert alert-danger w-100">
                     Une erreur est survenue. Veuillez vérifier votre connexion.
                   </div>
                  )}

                  {/* Data */}
                  {!isLoading && !error && Array.isArray(data) && data.length > 0 && (

                    data.slice(0, 15).map((product, index) => (
                      <ProductCard
                        key={index}
                        product={product}
                        detail={() => handleEdit(product)}
                      />
                    ))
                  )}

                  {/* Liste vide */}
                  {!isLoading && !error && Array.isArray(data) && data.length === 0 && (
                    <div className="bg-white border p-4 text-center text-secondary w-100">
                      La liste des produits de cette catégorie est vide.
                    </div>
                  )}

                </div>
              </div>
              
            </div>
        </div>

        {/* Modal de previsualisation */}
        {
          selectedProduct && ( <ProductModal show={showDetail} product={selectedProduct} onHide={() => setShowDetail(false)} /> )
        }   
    </div>
  );
}